/* eslint-disable no-prototype-builtins */
import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useNavigate, useParams, Link } from 'react-router-dom'

import Card from '@mui/material/Card'
import CardHeader from '@mui/material/CardHeader'
import CardMedia from '@mui/material/CardMedia'
import CardContent from '@mui/material/CardContent'
import CardActions from '@mui/material/CardActions'
import Collapse from '@mui/material/Collapse'
import Avatar from '@mui/material/Avatar'
import IconButton from '@mui/material/IconButton'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import EditIcon from '@mui/icons-material/Edit'
// import { Link } from '@mui/material'
import StarIcon from '@mui/icons-material/Star'
import VisibilityIcon from '@mui/icons-material/Visibility'
import InfoIcon from '@mui/icons-material/Info'
import SendIcon from '@mui/icons-material/Send'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'

import { ExpandMore } from '../../../../helpers/cardHelpers'
import { getPayload, getTokenFromLocalStorage, userIsAuthenticated } from '../../../../helpers/storage'
import { positionChangeHeightSm, positionChangeWidthSm, swipelyticsPink, swipelyticsTurquoise, expertReviewDiscount } from '../../../../helpers/variableDefaults'
import useWindowDimensions from '../../../../helpers/windowDimensions'
import { standardButton, standardButtonWithObjectAndIndex } from '../../../../helpers/buttons'
import { dummyBox, capitalizeFirstLetter } from '../../../../helpers/globalHelpers'

import profPicDefault from '../../../../assets/seed-profpic-default-2.jpg'

const ReviewerItemCard = (props) => {
  
  // Window Dimensions
  const { height, width } = useWindowDimensions()

  // Destructure Props
  const { 
    reviewerProfileItem,
    reviewerProfileItemIndex,
    setSelectedReviewerProfile, 
    setReviewerProfileToView, 
    setOpenFullReviewerProfileModal, 
    stripePaymentForm, setStripePaymentForm,
    isDemo,
  } = props

  // Payload
  const payload = getPayload()

  // Navigate
  const navigate = useNavigate()

  // Params
  // const { userId } = useParams()

  // URL Path
  const urlPath = window.location.pathname

  // Tracks whether the card is expanded
  const [expanded, setExpanded] = useState(false)

  // Changes the card expanded state
  const handleExpandClick = () => {
    setExpanded(!expanded)
  }

  const handleViewFullReviewerProfilePressed = (e, reviewerProfileObj) => {
    e.preventDefault()
    // console.log('handleViewFullReviewerProfilePressed runs')
    // console.log('reviewerProfileObj ->', reviewerProfileObj)

    if (!isDemo) {
      setReviewerProfileToView(reviewerProfileObj)
    } else {
      // `/demo/${profileReview.bio.vitalInfo.firstName.toLowerCase()}/${profileReview.type}/${profileReview.reviewerProfile.bio.vitalInfo.firstName.toLowerCase().replace(/ /g,'')}/reviewer-profile`
      // const reviewerToSet = 
      setReviewerProfileToView(reviewerProfileObj)
    }
    setOpenFullReviewerProfileModal(true)
  }

  const handleSelectReviewerPressed = (e, reviewerProfileObj) => {
    e.preventDefault()
    // console.log('handleSelectReviewerPressed runs')
    // console.log('reviewerProfileObj ->', reviewerProfileObj)

    if (reviewerProfileObj.isCoach || reviewerProfileObj.isHotty) {
      setStripePaymentForm({ ...stripePaymentForm, amount: reviewerProfileObj.reviewRate * 100 > 0 ? reviewerProfileObj.reviewRate * 100 : 3000 })
    }

    setSelectedReviewerProfile(reviewerProfileObj)
    window.scrollTo(0, 0)
  }


  return (
    <Box 
      sx={{ 
        width: '100%',
        display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
      }}
    >
      {/* Preview */}
      <Box
        sx={{
          width: '100%',
          display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
        }}
      >
        {/* Profile Picture */}
        <Box
          sx={{
            mt: 1,
            width: '100%',
            display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'flex-start',
          }}
        >
          <Box
            sx={{ 
              my: 0,
              width: width < positionChangeWidthSm ? '200px' : '200px',
              height: width < positionChangeWidthSm ? '200px' : '200px',
              backgroundImage: `url(${reviewerProfileItem.profilePicture})`,
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              boxShadow: 3, 
              borderRadius: '50%', 
              display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', 
            }}
          />
        </Box>

        {/* Name, Age, Gender, Sexuality, rate */}
        <Box
          sx={{
            mt: 1,
            width: '100%',
            display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
          }}
        >
          <Typography
            textAlign={'center'}
            sx={{
              width: '100%',
              // backgroundColor: 'orange',
              fontWeight: 'bold',
              fontSize: '18px',
            }}
          >
            {`${reviewerProfileItem.bio.vitalInfo.firstName}, ${reviewerProfileItem.bio.vitalInfo.age}`}
          </Typography>
          {reviewerProfileItem.isAIReviewer &&
            <Typography
              textAlign={'center'}
              sx={{
                width: '100%',
                // backgroundColor: 'orange',
                // fontWeight: 'bold',
                // fontSize: '18px',
              }}
            >
              {`${reviewerProfileItem.bio.vitalInfo.gender}`}
              {/* {`${reviewerProfileItem.isAIReviewer ? 'AI' : reviewerProfileItem.isFriendReviewer ? 'Friend' : 'Expert' }`} */}
            </Typography>
          }
          {reviewerProfileItem.isAIReviewer &&
            <Typography
              textAlign={'center'}
              sx={{
                width: '100%',
                // backgroundColor: 'orange',
                // fontWeight: 'bold',
                // fontSize: '18px',
              }}
            >
              {`${reviewerProfileItem.bio.vitalInfo.sexuality}`}
              {/* {`${reviewerProfileItem.isAIReviewer ? '$10/Review' : '$80/Review' }`} */}
            </Typography>
          }

          {/* Rate */}
          {!reviewerProfileItem.isAIReviewer &&
            <Typography
              textAlign={'center'}
              sx={{
                width: '100%',
                // backgroundColor: 'orange',
                // fontWeight: 'bold',
                // fontSize: '18px',
              }}
            >
              {`$${reviewerProfileItem.reviewRate}/review`}
              {/* {`${reviewerProfileItem.isAIReviewer ? '$10/Review' : '$80/Review' }`} */}
            </Typography>
          }
        </Box>

        {/* About Me */}
        <Box
          sx={{
            mt: 0,
            // mt: 2, py: 2, px: 2,
            width: '100%',
            height: '80px',
            backgroundColor: reviewerProfileItem.isFeatured ? 'mistyrose' : 'isCoach' in reviewerProfileItem && reviewerProfileItem.isCoach ? 'lightyellow' : 'white',
            // border: 'isCoach' in reviewerProfileItem && reviewerProfileItem.isCoach ? 2 : 0,
            // borderColor: 'darkgray',
            // borderRadius: 3,
            display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
          }}
        >
          <Typography
            textAlign={'center'}
            sx={{
              fontStyle: 'isCoach' in reviewerProfileItem && reviewerProfileItem.isCoach ? '' : 'italic',
              fontWeight: (('isCoach' in reviewerProfileItem && reviewerProfileItem.isCoach) || ('isFeatured' in reviewerProfileItem && reviewerProfileItem.isFeatured)) ? 'bold' : '',
              display: '-webkit-box',
              overflow: 'hidden',
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: 3,
              backgroundColor: reviewerProfileItem.isFeatured ? 'mistyrose' : 'isCoach' in reviewerProfileItem && reviewerProfileItem.isCoach ? 'lightyellow' : 'white',
            }}
          >
            {'isCoach' in reviewerProfileItem
              && reviewerProfileItem.isCoach 
              ?
              `${reviewerProfileItem.isFeatured ? `Featured Dating Expert` : `Professional Dating Coach`}`
              :
              reviewerProfileItem.isHotty 
                ?
                reviewerProfileItem.isFeatured ? `Featured Hotty Reviewer` : `Hotty Reviewer`
                :
                reviewerProfileItem.isAIReviewer
                  ?
                  `AI Reviewer`
                  :
                  'bio' in reviewerProfileItem
                  && 'aboutMe' in reviewerProfileItem.bio
                  && reviewerProfileItem.bio.aboutMe.length > 0
                    ?
                    reviewerProfileItem.bio.aboutMe[0]
                    :
                    `(No About Me for this reviewer)`
            }
          </Typography>
        </Box>

      </Box>

      {/* Buttons */}
      <Box
        sx={{
          mt: 1,
          width: '100%',
          display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
        }}
      >
        {/* View Full Profile Button */}
        {standardButtonWithObjectAndIndex(
          'View Profile', 
          'button',
          'contained',
          false,
          'primary', 
          0,
          0,
          0,
          width > 300 ? '220px' : '95%', 
          '45px', 
          handleViewFullReviewerProfilePressed,
          reviewerProfileItem,
          reviewerProfileItemIndex
        )}

        {/* Select Reviewer Button */}
        {standardButtonWithObjectAndIndex(
          'Select Reviewer', 
          'button',
          'contained',
          false,
          'secondary', 
          1,
          0,
          0,
          width > 300 ? '220px' : '45%', 
          '45px', 
          handleSelectReviewerPressed,
          reviewerProfileItem,
          reviewerProfileItemIndex
        )}

      </Box>
      
    </Box>
  )
}

export default ReviewerItemCard